import React from "react";
import {WindowContext} from '@web/hooks/context';
import {QuoteLeftIcon} from '@web/assets/icons';
import {Button, List, Tag, Typography} from 'antd';
import Footer from './components/AppFooter';
// import {useSelector} from 'react-redux';

function AppAddTask(props) {
  const [isMobile, width, height] = React.useContext(WindowContext);
  // const dispatch = useDispatch();
  // const task = useSelector((state) => state.Content?.data?.[props.path]);

  // React.useEffect(() => {
  //   if (props.isActive === false) return;
  //   props.setContext &&
  //   props.setContext({task, path: props.path, response: {}});
  //   props.path &&
  //   dispatch(aiActions.setActiveUserTask(props.path));
  // }, [task, props.path, props.isActive, props.setContext]);

  // const bigScreen = width > 1728;

  return <AppCenterWrapper isMobile={isMobile} height={height}>
    <div style={{width: "100%", maxWidth: 900}}>
      <div className="space space-col">
        <Typography.Title>Agents</Typography.Title>
        <Typography.Text className="muted">
          Line Agents do all those things you want to do, but don't have the time
        </Typography.Text>
        <br/>
        <List size="large">
          <List.Item actions={[<Button size="large" ghost><Tag className="muted rounded">ADD</Tag></Button>]}>
            <div className="space space-center-y"><h2><QuoteLeftIcon size={18} className="muted"/> &nbsp;Lookup LinkedIn when someone new emails me</h2><span className="muted"></span></div>
          </List.Item>
          <List.Item
            actions={[<Button size="large" ghost><Tag className="muted rounded">ADD</Tag></Button>]}>
            <div className="space space-center-y"><h2><QuoteLeftIcon size={18} className="muted"/> &nbsp;Weekly hikes based on weather forecast</h2></div>
          </List.Item>
          <List.Item
            actions={[<Button size="large" ghost><Tag className="muted rounded">ADD</Tag></Button>]}>
            <div className="space space-center-y"><h2><QuoteLeftIcon size={18} className="muted"/> &nbsp;Daily market summary for tech stocks</h2></div>
          </List.Item>
          <List.Item
            actions={[<Button size="large" ghost><Tag className="muted rounded">ADD</Tag></Button>]}>
            <div className="space space-center-y"><h2><QuoteLeftIcon size={18} className="muted"/> &nbsp;Remind Sally to take her umbrella if it will rain</h2></div>
          </List.Item>
          <List.Item
            actions={[<Button size="large" ghost><Tag className="muted rounded">ADD</Tag></Button>]}>
            <div className="space space-center-y"><h2><QuoteLeftIcon size={18} className="muted"/> &nbsp;Create social media posts based on my best work</h2></div>
          </List.Item>
        </List>
      </div>
      <div style={{width: "100%", paddingTop: "10px"}}>
        <Footer
          onNext={() => props.markCompleteAndNavigateNext(props.path)}
          onExit={props.onExit}
        />
      </div>
    </div>
  </AppCenterWrapper>
}

export default AppAddTask;
